import { IconButton, InputAdornment } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { ChangeEvent, MouseEvent } from 'react';
import { Input } from './styles';

type InputProps = {
  label: string;
  value: string;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleChangeVisibility: () => void;
  isPasswordVisible: boolean;
  error: boolean;
}

const InputComponent = ({ label, value, handleChange, error, isPasswordVisible, handleChangeVisibility }: InputProps) => {
  return (
    <Input
      label={label}
      variant="outlined"
      type={isPasswordVisible ? 'text' : 'password'}
      onChange={handleChange}
      value={value}
      error={error}
      autoComplete='off'
      InputProps={{
        endAdornment: <InputAdornment position="end">
          <IconButton
            aria-label="toggle password visibility"
            onClick={handleChangeVisibility}
            onMouseDown={(e: MouseEvent) => {
              e.preventDefault()
            }}
          >
            {isPasswordVisible ? <Visibility /> : <VisibilityOff />}
          </IconButton>
        </InputAdornment>,
      }}
    />
  )
};

export default InputComponent;